export default "__VITE_ASSET__Cv1tQ9Rg__"